<template>
    <div class="cc-dreifachbindung">
        <ul>
            <li>sp<sup>1</sup>-Hybridisierung</li>
            <li>1 * σ-Bindung + 2* π-Bindung</li>
            <li>keine freie Drehbarkeit</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'cc-dreifachbindung',
};
</script>
